document.addEventListener('DOMContentLoaded', function() {
  const accountLink = document.querySelector('.site-header-actions__account-link');
  const dropdown = document.querySelector('.jetter-machines-dropdown');
  
  if (!accountLink || !dropdown) return;
  
  let isDropdownOpen = false;
  let hideTimeout;
  
  // Function to show dropdown
  function showDropdown() {
    clearTimeout(hideTimeout);
    dropdown.classList.add('show');
    isDropdownOpen = true;
  }
  
  // Function to hide dropdown with delay
  function hideDropdown() {
    hideTimeout = setTimeout(() => {
      dropdown.classList.remove('show');
      isDropdownOpen = false;
    }, 300); // 300ms delay before hiding
  }
  
  // Show dropdown on account link hover
  accountLink.addEventListener('mouseenter', showDropdown);
  
  // Keep dropdown visible when hovering over it
  dropdown.addEventListener('mouseenter', function() {
    clearTimeout(hideTimeout);
  });
  
  // Hide dropdown when leaving both account link and dropdown
  accountLink.addEventListener('mouseleave', function(e) {
    // Check if we're moving to the dropdown
    const relatedTarget = e.relatedTarget;
    if (!dropdown.contains(relatedTarget)) {
      hideDropdown();
    }
  });
  
  dropdown.addEventListener('mouseleave', hideDropdown);
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!accountLink.contains(e.target) && !dropdown.contains(e.target)) {
      if (isDropdownOpen) {
        dropdown.classList.remove('show');
        isDropdownOpen = false;
        clearTimeout(hideTimeout);
      }
    }
  });
  
  // Handle keyboard navigation
  accountLink.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (isDropdownOpen) {
        hideDropdown();
      } else {
        showDropdown();
      }
    }
    
    if (e.key === 'Escape' && isDropdownOpen) {
      dropdown.classList.remove('show');
      isDropdownOpen = false;
      clearTimeout(hideTimeout);
    }
  });
  
  // Handle focus events for accessibility
  accountLink.addEventListener('focus', function() {
    showDropdown();
  });
  
  // Close dropdown when tabbing away from the entire dropdown area
  document.addEventListener('focusin', function(e) {
    if (!accountLink.contains(e.target) && !dropdown.contains(e.target)) {
      if (isDropdownOpen) {
        dropdown.classList.remove('show');
        isDropdownOpen = false;
        clearTimeout(hideTimeout);
      }
    }
  });
}); 